export default __webpack_public_path__ + "static/media/visa_horizontal_virtual_black_background.89d3c671.svg";